import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "dialog-custom__header" }
const _hoisted_2 = { class: "dialog-custom__title" }
const _hoisted_3 = { class: "dialog-custom__content form-custom" }
const _hoisted_4 = { class: "dialog-plant-create__grid--even" }
const _hoisted_5 = { style: {"height":"calc(100vh - 300px)"} }
const _hoisted_6 = {
  class: "p-field",
  style: {"margin-right":"10px","margin-left":"10px"}
}
const _hoisted_7 = {
  class: "d-flex align-items-center",
  style: {"justify-content":"space-between"}
}
const _hoisted_8 = { class: "p-field-label mb-3" }
const _hoisted_9 = { class: "card__head d-flex align-items-center" }
const _hoisted_10 = { class: "d-flex align-items-center ml-2" }
const _hoisted_11 = { class: "bt-icon my-auto bt-icon--m text-gray" }
const _hoisted_12 = { class: "ml-3" }
const _hoisted_13 = { class: "mb-0" }
const _hoisted_14 = { style: {"height":"calc(100vh - 300px)"} }
const _hoisted_15 = {
  class: "p-field",
  style: {"margin-right":"10px","margin-left":"10px"}
}
const _hoisted_16 = { class: "p-field-label mb-3" }
const _hoisted_17 = { class: "card__head d-flex align-items-center" }
const _hoisted_18 = { class: "d-flex align-items-center ml-2" }
const _hoisted_19 = { class: "bt-icon my-auto bt-icon--m text-gray" }
const _hoisted_20 = { class: "ml-3" }
const _hoisted_21 = { class: "mb-0" }
const _hoisted_22 = { class: "p-field mx-2" }
const _hoisted_23 = { class: "p-field-label mb-3" }
const _hoisted_24 = {
  key: 0,
  class: "p-field my-4"
}
const _hoisted_25 = { class: "p-field-label mb-2" }
const _hoisted_26 = {
  class: "p-field mb-5",
  style: {"margin-right":"10px","margin-left":"10px"}
}
const _hoisted_27 = { class: "p-field-label mb-3" }
const _hoisted_28 = { class: "card__head d-flex align-items-center" }
const _hoisted_29 = { class: "d-flex align-items-center ml-2" }
const _hoisted_30 = { class: "bt-icon my-auto bt-icon--m text-gray" }
const _hoisted_31 = { class: "ml-3" }
const _hoisted_32 = { class: "mb-0" }
const _hoisted_33 = { class: "dialog-custom__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HelpPopupButton = _resolveComponent("HelpPopupButton")
  const _component_ListItemRadio = _resolveComponent("ListItemRadio")
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_NumberButtons = _resolveComponent("NumberButtons")
  const _component_Card = _resolveComponent("Card")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("header", _hoisted_1, [
      _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t("AppResourceEP.SetupWizardStructureSetupTitle")), 1)
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode("span", null, [
                _createVNode("h5", null, _toDisplayString(_ctx.$t("AppResourceEP.RiserInterface")), 1),
                _createVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("AppResourceEP.AreThereRisersQuestion")), 1)
              ]),
              _createVNode(_component_HelpPopupButton, {
                helpType: _ctx.HelpType.RiserInterface
              }, null, 8, ["helpType"])
            ]),
            _createVNode(_component_ListItemRadio, {
              modelValue: _ctx.hasRiserInterface,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.hasRiserInterface = $event)),
              label: _ctx.$t('AppResource.No'),
              inputId: "riserNo",
              name: "riserInterface",
              value: false
            }, null, 8, ["modelValue", "label"]),
            _createVNode(_component_ListItemRadio, {
              modelValue: _ctx.hasRiserInterface,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.hasRiserInterface = $event)),
              label: _ctx.$t('AppResource.Yes'),
              inputId: "riserYes",
              name: "riserInterface",
              value: true,
              last: ""
            }, null, 8, ["modelValue", "label"]),
            (_ctx.hasRiserInterface)
              ? (_openBlock(), _createBlock(_component_Card, {
                  key: 0,
                  class: "card--slim my-4"
                }, {
                  content: _withCtx(() => [
                    _createVNode("div", _hoisted_9, [
                      _createVNode("div", _hoisted_10, [
                        _createVNode("span", _hoisted_11, [
                          _createVNode(_component_InlineSvgScoped, {
                            src: 
                                                require(`@/assets/images/entrancePlants/icon-riser.svg`)
                                            ,
                            "aria-label": "icon-riser"
                          }, null, 8, ["src"])
                        ]),
                        _createVNode("div", _hoisted_12, [
                          _createVNode("h6", _hoisted_13, _toDisplayString(_ctx.$t("AppResourceEP.Risers")), 1)
                        ])
                      ]),
                      _createVNode(_component_NumberButtons, {
                        class: "ml-auto",
                        modelValue: _ctx.riserNumber,
                        "min-value": 1,
                        "max-value": 30,
                        onIncrement: _cache[3] || (_cache[3] = ($event: any) => (_ctx.riserNumber++)),
                        onDecrement: _cache[4] || (_cache[4] = ($event: any) => (_ctx.riserNumber--))
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("div", _hoisted_14, [
          _createVNode(_component_ElScrollbar, { class: "dialog-scroll" }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_15, [
                _createVNode("h5", null, _toDisplayString(_ctx.$t("AppResourceEP.Backbone")), 1),
                _createVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("AppResourceEP.SwitchboardsOnBackbone")), 1),
                _createVNode(_component_ListItemRadio, {
                  modelValue: _ctx.hasSwitchboardOnBackbone,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.hasSwitchboardOnBackbone = $event)),
                  label: _ctx.$t('AppResource.No'),
                  inputId: "backboneSwitchboardNo",
                  name: "backboneSwitchboards",
                  value: false
                }, null, 8, ["modelValue", "label"]),
                _createVNode(_component_ListItemRadio, {
                  modelValue: _ctx.hasSwitchboardOnBackbone,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.hasSwitchboardOnBackbone = $event)),
                  label: _ctx.$t('AppResource.Yes'),
                  inputId: "backboneSwitchboardYes",
                  name: "backboneSwitchboards",
                  value: true,
                  last: ""
                }, null, 8, ["modelValue", "label"]),
                (_ctx.hasSwitchboardOnBackbone)
                  ? (_openBlock(), _createBlock(_component_Card, {
                      key: 0,
                      class: "card--slim my-4"
                    }, {
                      content: _withCtx(() => [
                        _createVNode("div", _hoisted_17, [
                          _createVNode("div", _hoisted_18, [
                            _createVNode("span", _hoisted_19, [
                              _createVNode(_component_InlineSvgScoped, {
                                src: 
                                                    require(`@/assets/images/entrancePlants/icon-switchboard.svg`)
                                                ,
                                "aria-label": "icon-switchboard"
                              }, null, 8, ["src"])
                            ]),
                            _createVNode("div", _hoisted_20, [
                              _createVNode("h6", _hoisted_21, _toDisplayString(_ctx.$t("AppResourceEP.Switchboards")), 1)
                            ])
                          ]),
                          _createVNode(_component_NumberButtons, {
                            class: "ml-auto",
                            modelValue: _ctx.switchboardNumber,
                            "min-value": 1,
                            "max-value": 30,
                            onIncrement: _cache[7] || (_cache[7] = ($event: any) => (_ctx.switchboardNumber++)),
                            onDecrement: _cache[8] || (_cache[8] = ($event: any) => (_ctx.switchboardNumber--))
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.hasRiserInterface)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createVNode("div", _hoisted_22, [
                      _createVNode("label", _hoisted_23, _toDisplayString(_ctx.$t("AppResourceEP.ApartmentsOnBackbone")), 1),
                      _createVNode(_component_ListItemRadio, {
                        modelValue: _ctx.hasApartmentsOnBackbone,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.hasApartmentsOnBackbone = $event)),
                        label: _ctx.$t('AppResource.No'),
                        inputId: "backboneApartmentsNo",
                        name: "backboneApartments",
                        value: false
                      }, null, 8, ["modelValue", "label"]),
                      _createVNode(_component_ListItemRadio, {
                        modelValue: _ctx.hasApartmentsOnBackbone,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.hasApartmentsOnBackbone = $event)),
                        label: _ctx.$t('AppResource.Yes'),
                        inputId: "backboneApartmentsYes",
                        name: "backboneApartments",
                        value: true,
                        last: ""
                      }, null, 8, ["modelValue", "label"]),
                      (_ctx.hasApartmentsOnBackbone)
                        ? (_openBlock(), _createBlock("div", _hoisted_24, [
                            _createVNode("label", _hoisted_25, _toDisplayString(_ctx.$t("AppResourceEP.NumberOfApartmentsUpper")) + ": ", 1),
                            _createVNode(_component_Dropdown, {
                              class: "w-100",
                              modelValue: _ctx.apartmentNumber,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.apartmentNumber = $event)),
                              options: _ctx.noAppartmentOptions(),
                              optionLabel: "label",
                              optionValue: "value"
                            }, null, 8, ["modelValue", "options"])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("div", _hoisted_26, [
                      _createVNode("label", _hoisted_27, _toDisplayString(_ctx.$t("AppResourceEP.GatesOnBackbone")), 1),
                      _createVNode(_component_ListItemRadio, {
                        modelValue: _ctx.hasGatesOnBackbone,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.hasGatesOnBackbone = $event)),
                        label: _ctx.$t('AppResource.No'),
                        inputId: "backboneGatesNo",
                        name: "backboneGates",
                        value: false
                      }, null, 8, ["modelValue", "label"]),
                      _createVNode(_component_ListItemRadio, {
                        modelValue: _ctx.hasGatesOnBackbone,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.hasGatesOnBackbone = $event)),
                        label: _ctx.$t('AppResource.Yes'),
                        inputId: "backboneGatesYes",
                        name: "backboneGates",
                        value: true,
                        last: ""
                      }, null, 8, ["modelValue", "label"]),
                      (_ctx.hasGatesOnBackbone)
                        ? (_openBlock(), _createBlock(_component_Card, {
                            key: 0,
                            class: "card--slim my-4"
                          }, {
                            content: _withCtx(() => [
                              _createVNode("div", _hoisted_28, [
                                _createVNode("div", _hoisted_29, [
                                  _createVNode("span", _hoisted_30, [
                                    _createVNode(_component_InlineSvgScoped, {
                                      src: 
                                                        require(`@/assets/images/entrancePlants/icon-gate.svg`)
                                                    ,
                                      "aria-label": "icon-gate"
                                    }, null, 8, ["src"])
                                  ]),
                                  _createVNode("div", _hoisted_31, [
                                    _createVNode("h6", _hoisted_32, _toDisplayString(_ctx.$t("AppResourceEP.Gates")), 1)
                                  ])
                                ]),
                                _createVNode(_component_NumberButtons, {
                                  class: "ml-auto",
                                  modelValue: _ctx.gateNumber,
                                  "min-value": 1,
                                  "max-value": 30,
                                  onIncrement: _cache[14] || (_cache[14] = ($event: any) => (_ctx.gateNumber++)),
                                  onDecrement: _cache[15] || (_cache[15] = ($event: any) => (_ctx.gateNumber--))
                                }, null, 8, ["modelValue"])
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode("footer", _hoisted_33, [
      _createVNode(_component_Button, {
        onClick: _ctx.handleBackButton,
        label: _ctx.$t('AppResource.Back'),
        class: "p-button-text mr-3"
      }, null, 8, ["onClick", "label"]),
      _createVNode(_component_Button, {
        onClick: _ctx.handleNextButton,
        label: _ctx.$t('AppResource.Continue'),
        class: "p-button-rounded p-button-raised p-button--m"
      }, null, 8, ["onClick", "label"])
    ])
  ], 64))
}